import React from 'react';
import { Card, Badge } from './ui';
import { CheckCircle, Book, BookOpen, BookMarked, Library, Notebook, BookType, Gift } from 'lucide-react';
export function Product() {
  const tomos = [{
    icon: <Book className="w-8 h-8 text-blue-400" data-id="element-99" data-mp="28cdesn9jy0r1" />,
    color: 'bg-blue-500/10 border-blue-500/20',
    title: 'TOMO 1 — LA MENTE MAESTRA',
    subtitle: 'La base que hace funcionar todo',
    desc: 'Método completo de operación con IA, stack de herramientas low-cost, configuración del ecosistema digital, prompts fundacionales y planilla maestra de proyectos.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-emerald-400" data-id="element-100" data-mp="2r21s72hd0yin" />,
    color: 'bg-emerald-500/10 border-emerald-500/20',
    title: 'TOMO 2 — FACTOR CONTENIDO',
    subtitle: 'Reels, blogs y ghostwriting sin bloqueo creativo',
    desc: '28 flujos de trabajo para crear contenido viral. Guiones para Reels, estructuras de TikTok, artículos SEO y servicios de ghostwriting. Listos para entregar en menos de una hora.'
  }, {
    icon: <BookMarked className="w-8 h-8 text-amber-400" data-id="element-101" data-mp="1vm08hd3c23gl" />,
    color: 'bg-amber-500/10 border-amber-500/20',
    title: 'TOMO 3 — EL DISEÑADOR INVISIBLE',
    subtitle: 'Diseño profesional sin ser diseñador',
    desc: '32 flujos de creación de imágenes, logos, mockups y arte digital. Todo con herramientas gratuitas o de bajo costo. El tomo que más clientes genera en menos tiempo.'
  }, {
    icon: <Library className="w-8 h-8 text-rose-400" data-id="element-102" data-mp="2egxe8t9xnsql" />,
    color: 'bg-rose-500/10 border-rose-500/20',
    title: 'TOMO 4 — ASISTENTE PRO',
    subtitle: 'El manual de productividad definitivo',
    desc: '25 sistemas de automatización para emails, notas, data y tareas B2B. La Matriz de Servicios: 6 tipos de asistencia × 5 industrias = 30 servicios distintos que podés ofrecer hoy.'
  }, {
    icon: <Notebook className="w-8 h-8 text-purple-400" data-id="element-103" data-mp="2x7ojpjqsuyzp" />,
    color: 'bg-purple-500/10 border-purple-500/20',
    title: 'TOMO 5 — VENTAS DORADAS',
    subtitle: 'El sistema de cierre de clientes completo',
    desc: '17 scripts de venta y la estructura de landing pages que convierte. Cómo escribir emails que generan respuesta. Meta Ads desde cero con IA. El tomo que transforma el conocimiento en contratos.'
  }, {
    icon: <BookType className="w-8 h-8 text-orange-400" data-id="element-104" data-mp="1757g5q5m279r" />,
    color: 'bg-orange-500/10 border-orange-500/20',
    title: 'TOMO 6 — LA ESCALADA REAL',
    subtitle: 'De operador a dueño de sistema',
    desc: '35+ flujos para escalar, cobrar en dólares, crear productos digitales propios y construir sistemas que trabajan sin tu presencia constante.'
  }];
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-105" data-mp="1pvxhvbjg3o11">
      <div className="max-w-5xl mx-auto" data-id="element-106" data-mp="1ptujo4852ol8">
        <div className="text-center mb-10" data-id="element-107" data-mp="ghcm78n6mgf">
          <Badge variant="success" className="mb-4" data-id="element-108" data-mp="h99dldz6q8a">
            🏆 PUNTO DIGITAL™ — MEGAPACK RECURSOS DIGITALES
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-109" data-mp="2759j31nc6umu">
            6 Tomos + 5 Bonos — El sistema completo para dominar la IA
          </h2>
          <p className="text-xl text-slate-400" data-id="element-110" data-mp="2c3un7c5plygk">
            300+ páginas — 100+ prompts — Listo para aplicar hoy
          </p>
          <div className="flex flex-wrap justify-center gap-2 mt-6 text-sm font-medium text-brand-400" data-id="element-111" data-mp="1yb4xoxqz2bep">
            <span data-id="element-112" data-mp="1oerun99jel7a">Sistema</span> <span className="text-slate-600" data-id="element-113" data-mp="1oe8oept91l93">→</span>
            <span data-id="element-114" data-mp="1odgsfdvqplia">Contenido</span> <span className="text-slate-600" data-id="element-115" data-mp="1oh4j859svttb">→</span>
            <span data-id="element-116" data-mp="1teo07cxvukoy">Diseño</span> <span className="text-slate-600" data-id="element-117" data-mp="1tf63uumvk16w">→</span>
            <span data-id="element-118" data-mp="1feliprthlta8">Asistencia</span> <span className="text-slate-600" data-id="element-119" data-mp="1ffevpaj1hf0t">→</span>
            <span data-id="element-120" data-mp="1jfp22oaqu7g7">Ventas</span> <span className="text-slate-600" data-id="element-121" data-mp="1jf5iz49cxd0l">→</span>
            <span data-id="element-122" data-mp="1jfyoy30hryho">Escalada</span>
          </div>
        </div>

        <div className="mb-10" data-id="element-123" data-mp="39t628162nis1">
          <h3 className="text-xl font-bold text-white mb-5 flex items-center gap-3" data-id="element-124" data-mp="39sw8c2hworh2">
            <span className="text-3xl" data-id="element-125" data-mp="3dt6fvjlcjpy1">🤖</span> 6 TOMOS COMPLETOS
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-126" data-mp="2p20rlb91qz3s">
            {tomos.map((tomo, i) => <Card key={i} className={`border ${tomo.color}`} data-id="element-127" data-mp="2k3pfetva4cie" data-mpi={i}>
                <div className="flex items-start gap-4" data-id="element-128" data-mp="2f4w1x1fzsli8">
                  <div className="p-3 bg-slate-900 rounded-xl shrink-0" data-id="element-129" data-mp="2f3bahkoz5iol">
                    {tomo.icon}
                  </div>
                  <div data-id="element-130" data-mp="2a85neiju5xyx">
                    <h4 className="font-bold text-white text-lg mb-1" data-id="element-131" data-mp="264pu9w6z6fqz">
                      {tomo.title}
                    </h4>
                    <p className="text-brand-400 text-sm font-medium mb-3" data-id="element-132" data-mp="21cpohn484smh">
                      {tomo.subtitle}
                    </p>
                    <p className="text-slate-400 text-sm leading-relaxed" data-id="element-133" data-mp="1wc1z15vn8jud">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </Card>)}
          </div>
        </div>

        <Card className="bg-slate-900" data-id="element-134" data-mp="1iedcltlxh4n7">
          <h4 className="font-bold text-xl text-white mb-6" data-id="element-135" data-mp="1iff04xk4rjlt">
            Cada tomo incluye:
          </h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-136" data-mp="3u41pp9cczd2q">
            {['Flujos completos con paso a paso detallado', 'Tablas de herramientas y costos reales', 'Tips de automatización y optimización', 'Sistema de servicios por nivel de experiencia', 'Costos estimados en pesos argentinos y dólares', 'Variantes económicas de cada herramienta', 'Planilla de seguimiento lista para usar', '100% pensado para la realidad argentina'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-137" data-mp="3kbdweokl7r8r" data-mpi={i}>
                <CheckCircle className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-138" data-mp="3p3e08s3s34am" />
                <span className="text-slate-300" data-id="element-139" data-mp="2rni2frmekdfo">{item}</span>
              </div>)}
          </div>
        </Card>
      </div>
    </section>;
}
export function Bonuses() {
  const bonuses = [{
    title: 'Kit de Arranque Rápido IA en 24 Horas',
    desc: 'El plan exacto para conseguir tu primer cliente en 24 horas con las herramientas del Tomo 1. Sin experiencia previa.',
    value: 'USD 9.00'
  }, {
    title: 'Biblioteca de 100 Prompts Vendedores',
    desc: 'Los 100 prompts que más facturan en diseño, contenido, ventas y asistencia. Nunca más te quedás en blanco frente a la IA.',
    value: 'USD 8.00'
  }, {
    title: 'Tracker de Clientes y Primeros Ingresos IA',
    desc: 'Medí clientes, entregas e ingresos en un solo panel. Sabés en qué punto estás en 10 segundos.',
    value: 'USD 9.00'
  }, {
    title: 'Mini Guía de 30 Ideas de Servicios IA Rentables',
    desc: '30 servicios listos para ofrecer hoy, ordenados por dificultad y tiempo de entrega. Elegís uno y arrancás.',
    value: 'USD 8.00'
  }, {
    title: 'Pack de Scripts para Vender Servicios IA por DM',
    desc: 'Los mensajes exactos para cerrar por DM. Copiá, pegá y adaptá cuando el cliente duda.',
    value: 'USD 9.00'
  }];
  return <section className="py-12 px-4" data-id="element-140" data-mp="1cscv0xk6xbyz">
      <div className="max-w-5xl mx-auto" data-id="element-141" data-mp="1cte6h354c0h8">
        <div className="text-center mb-8" data-id="element-142" data-mp="1cq8i5q4bd2mk">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 flex items-center justify-center gap-3" data-id="element-143" data-mp="ytlg58xi7m9s">
            <Gift className="w-9 h-9 text-brand-400" data-id="element-144" data-mp="13spt8anju45e" />5 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-brand-400 font-bold uppercase tracking-widest" data-id="element-145" data-mp="1rik4wow4tmo2">
            Siempre incluidos. Sin costo adicional.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8" data-id="element-146" data-mp="1hrxtz7zd1kbp">
          {bonuses.map((bono, i) => <Card key={i} className="relative overflow-hidden group hover:border-brand-500/50 transition-colors" data-id="element-147" data-mp="1mq929ea0bmrt" data-mpi={i}>
              <div className="absolute top-0 right-0 bg-brand-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-148" data-mp="2aea7ad7z8l2h">
                BONO {i + 1}
              </div>
              <h4 className="font-bold text-white text-lg mb-3 pr-12 mt-2" data-id="element-149" data-mp="f5lyeqhxlsmy">
                {bono.title}
              </h4>
              <p className="text-slate-400 text-sm mb-6" data-id="element-150" data-mp="acsta1ijwiac">{bono.desc}</p>
              <div className="mt-auto pt-4 border-t border-slate-800 flex justify-between items-center" data-id="element-151" data-mp="5fsmfodvnbi6">
                <span className="line-through text-slate-500 text-sm" data-id="element-152" data-mp="h8w7bs93dk0">
                  Valor {bono.value}
                </span>
                <span className="text-emerald-400 font-bold" data-id="element-153" data-mp="y1lp7xz6aq4y">GRATIS</span>
              </div>
            </Card>)}
        </div>

        <div className="bg-gradient-to-r from-brand-900/50 to-emerald-900/50 border border-brand-500/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-154" data-mp="o4z6beqeq95k">
          <p className="text-slate-300 mb-2" data-id="element-155" data-mp="k5zvjdhzvi67">Valor real de los bonos</p>
          <p className="text-4xl font-black text-white mb-2 line-through decoration-red-500/50" data-id="element-156" data-mp="38wiv6b0ug2nk">
            USD 43.00
          </p>
          <p className="text-2xl font-bold text-emerald-400" data-id="element-157" data-mp="34w8osx953a86">
            → GRATIS con tu Megapack Recursos Digitales
          </p>
        </div>
      </div>
    </section>;
}